export const REGIONS_I = {
  path1200: [
    {lng: 24.00411996483533, lat: 50.41217305459017},
    {lng: 24.1203995988145,  lat: 50.57250724031178},
    {lng: 24.16215685792573, lat: 50.86239766866858},
    {lng: 23.86259705166704, lat: 51.15528896952564},
    {lng: 23.74558440235979, lat: 51.26947657171163},
    {lng: 23.68648614355181, lat: 51.46530211736827},
    {lng: 23.46720440514937, lat: 51.45069130181496},
    {lng: 22.87142913910542, lat: 51.43246806498597},
    {lng: 22.43119431862266, lat: 51.41151810372337},
    {lng: 22.25441653762764, lat: 51.24427481443212},
    {lng: 22.304665773777,   lat: 51.01677366003948},
    {lng: 23.71038704321501, lat: 50.37307074106346},
    {lng: 24.00411996483533, lat: 50.41217305459017}
    ],
    path1000: [
    {lng: 22.23583785848743, lat: 54.33231770092868},
    {lng: 22.48535005947793, lat: 54.00232700165047},
    {lng: 22.65099274396853, lat: 53.80428052910965},
    {lng: 22.6714001172452,  lat: 53.68272303322421},
    {lng: 22.51248882684868, lat: 53.49083765167077},
    {lng: 22.01827278575598, lat: 53.37287446927902},
    {lng: 21.66576957707571, lat: 53.3174478840612},
    {lng: 21.13807201563037, lat: 53.35730539023203},
    {lng: 20.62302745040646, lat: 53.70984997298256},
    {lng: 19.52394995264317, lat: 53.94814559528525},
    {lng: 18.1728683672584,  lat: 54.00544066979851},
    {lng: 16.92430252001028, lat: 53.81724208035281},
    {lng: 16.0717632315856,  lat: 53.45483105304123},
    {lng: 15.25210638588416, lat: 52.91650158971822},
    {lng: 14.67906876519738, lat: 52.48288602987108},
    {lng: 14.548250819787,   lat: 52.41054377612173},
    {lng: 14.50187559581375, lat: 52.2216622985779},
    {lng: 14.5625743269681,  lat: 51.90111526865551},
    {lng: 14.63797913735083, lat: 51.55251080483941},
    {lng: 14.83551944274852, lat: 51.44269760537835},
    {lng: 14.99079814758714, lat: 51.3759021910791},
    {lng: 16.66515730196338, lat: 50.93882495302981},
    {lng: 17.12644158582006, lat: 50.56872983524227},
    {lng: 17.34042870179445, lat: 50.32830113380634},
    {lng: 17.31476719136124, lat: 50.2668481736481},
    {lng: 17.43328273110251, lat: 49.97525362289768},
    {lng: 18.07598021455255, lat: 49.93079251225198},
    {lng: 18.0570570465098,  lat: 50.04176140406859},
    {lng: 18.0148092521012,  lat: 50.12693742124219},
    {lng: 18.25997873783467, lat: 50.35938199869691},
    {lng: 18.73321766630502, lat: 50.44308362261482},
    {lng: 19.04346782826498, lat: 50.3954378226674},
    {lng: 19.23790468438867, lat: 50.26249181177755},
    {lng: 19.30221914311495, lat: 50.11220769117063},
    {lng: 19.19017238274603, lat: 49.97770343981018},
    {lng: 19.10598097395515, lat: 49.89007518473445},
    {lng: 18.67975330941336, lat: 49.84463123067591},
    {lng: 18.55305287232526, lat: 49.84841342461153},
    {lng: 18.4970225822533,  lat: 49.68375119362887},
    {lng: 18.97612953391977, lat: 49.37668650262707},
    {lng: 19.79818403050148, lat: 49.17236232029833},
    {lng: 20.11082788751991, lat: 49.1370748918611},
    {lng: 21.71390747430153, lat: 49.38835461401546},
    {lng: 21.64168386772416, lat: 49.50012219350414},
    {lng: 21.63472876768876, lat: 49.64056298393374},
    {lng: 21.80457327106324, lat: 49.72407110841762},
    {lng: 22.11088167770825, lat: 49.78060065613386},
    {lng: 22.51051361098802, lat: 49.73984036658824},
    {lng: 22.83326590789926, lat: 49.65963013092735},
    {lng: 24.03135098110142, lat: 50.38375999438595},
    {lng: 24.29026713766243, lat: 50.91197165643114},
    {lng: 24.0359968969395,  lat: 52.98810879497642},
    {lng: 23.63709942402746, lat: 54.10958428890903},
    {lng: 23.03549642796059, lat: 54.45659251579364},
    {lng: 22.25892740351518, lat: 54.39506576529113},
    {lng: 22.23583785848743, lat: 54.33231770092868}
  ],
  path1100_2: [
    {lng: 18.8953174103303,  lat: 54.60877607231949},
    {lng: 18.51147347334792, lat: 54.83459191090011},
    {lng: 18.1143453299938,  lat: 54.87053728537521},
    {lng: 17.28567432377125, lat: 54.7669411875512},
    {lng: 16.41990477625775, lat: 54.5100147504249},
    {lng: 15.64397371266068, lat: 54.21126487247193},
    {lng: 15.18481400450691, lat: 54.14211773207715},
    {lng: 14.57279519157207, lat: 53.99271837587879},
    {lng: 14.21584879262644, lat: 53.92745184999307},
    {lng: 14.21358734312844, lat: 53.85729540397727},
    {lng: 14.31642692591908, lat: 53.81093225636874},
    {lng: 14.6127964638417,  lat: 53.8275002744758},
    {lng: 15.2434483195782,  lat: 54.02587697723344},
    {lng: 15.94563765480924, lat: 54.14609627900538},
    {lng: 16.19357526696917, lat: 54.17708745332265},
    {lng: 16.80053624267411, lat: 54.3518087266102},
    {lng: 17.15787646985928, lat: 54.5089641524832},
    {lng: 17.77777748324632, lat: 54.62104535225181},
    {lng: 18.39320542598401, lat: 54.42926148150821},
    {lng: 18.72675516566402, lat: 54.38836990015638},
    {lng: 18.8953174103303,  lat: 54.60877607231949}
  ],

  path1100: [
    {lng: 22.73857237084746, lat: 54.37884431635405},
    {lng: 23.14449097328397, lat: 53.90750889256095},
    {lng: 23.22095410498838, lat: 53.28388209278399},
    {lng: 23.18846722280194, lat: 53.14001662527868},
    {lng: 22.98234933038134, lat: 52.95764386802152},
    {lng: 22.35978980174236, lat: 52.76495861188582},
    {lng: 22.09235089646573, lat: 52.71176657313425},
    {lng: 21.02396035965957, lat: 52.47383258685686},
    {lng: 20.01006579998929, lat: 52.53738283506244},
    {lng: 19.53671247387858, lat: 52.70261341640209},
    {lng: 19.10569599390739, lat: 52.95189224656904},
    {lng: 18.50135365055382, lat: 53.06362025085958},
    {lng: 18.01409419546426, lat: 53.06491853807256},
    {lng: 16.73904184645881, lat: 52.76380842266541},
    {lng: 16.41862202793746, lat: 52.30334516039468},
    {lng: 16.52043768988839, lat: 51.48670682265895},
    {lng: 16.71410090926707, lat: 51.16638743302845},
    {lng: 17.60754201384796, lat: 50.80874592195453},
    {lng: 18.05475420894858, lat: 50.71543272137045},
    {lng: 19.023938381236,   lat: 50.71726989542677},
    {lng: 19.4246765893549,  lat: 50.53822952949934},
    {lng: 19.91153603665565, lat: 50.07727669417518},
    {lng: 20.30787695804504, lat: 49.97222037042373},
    {lng: 21.38587174025915, lat: 50.00096749657543},
    {lng: 22.02899873365538, lat: 49.95225313551457},
    {lng: 22.59360825585307, lat: 49.87628678584758},
    {lng: 22.94794976232312, lat: 49.77838207861365},
    {lng: 24.20406246882231, lat: 50.52751901319937},
    {lng: 24.26022662340288, lat: 50.86720070275784},
    {lng: 24.01327118000353, lat: 52.70706667835604},
    {lng: 23.76815925673915, lat: 53.78379714732773},
    {lng: 23.30838575359073, lat: 54.45398493063789},
    {lng: 22.88238426616685, lat: 54.46525068022685},
    {lng: 22.73857237084746, lat: 54.37884431635405}
  ]
}



// WEBPACK FOOTER //
// /Users/michaldudziak/Desktop/Projekty/Projekt-Sunroof/Sunroof/src/app/services/regions_i.ts